export default "__VITE_ASSET__hiWJ3jhW__"